import SceneObject from "../scene/sceneobject";
import ShaderService from "../shader/shader_service";
import ResourceService from "../resource/resourceservice";
import Stage from "../stage/stage";
import { SoundAsset, SoundResource } from "../resource/soundresource";
import SoundService from "./sound_service";

export default class SoundObject extends SceneObject 
{
     //audio name must have extention , should be 48k 32 bit mono, supports .wav .mp3 .aac .m4a
    audio_name:string;
    protected panner: PannerNode | null = null;
    protected sound_resource:SoundResource | null = null;
    protected sound_asset:SoundAsset | null = null;
    private sound_service:SoundService;
    private gain_node: GainNode | null = null;
    private start_time: number = 0;
    private pause_time: number = 0;
    private loop: boolean = false;
    private source: AudioBufferSourceNode | null = null;

    constructor(key: string, audio_name:string,x:number,y:number, z:number)
    {
         super(key);
         this.audio_name = audio_name;
         this.sound_service = Stage.instance().sound_service;
         this.location(x,y,z);
          
    }

    async build(
        device: GPUDevice,
        format: GPUTextureFormat,
        shader_service: ShaderService,
        resource_service: ResourceService
      ): Promise<void> 
      {
            
             this.sound_resource = await resource_service.getSound(this.audio_name);
             this.sound_asset = this.sound_resource.value;
             this.panner = new PannerNode(this.sound_service.context, { panningModel: 'HRTF',  distanceModel: 'inverse' });
             this.panner.connect(this.sound_service.context.destination);
             this.gain_node = new GainNode(this.sound_service.context, { gain: 1.0 });


      }

      location(x:number,y:number, z:number)
      {
        this.transform.set_position(x,y,z);
        this.transform.update_matrix();
      }

      play(loop:boolean):void
      {
          if(!this.panner || ! this.sound_asset || !this.gain_node ) return;

           this.loop = loop;
           this.tick_panner();
           this.source = this.sound_service.context.createBufferSource();
           this.source.buffer = this.sound_asset.buffer;
           this.source.connect(this.panner);
           this.source.loop = this.loop;
           this.start_time = this.sound_service.context.currentTime;
           
           this.source.onended = () => {
           this.source = null;
           };

           this.source.connect(this.gain_node);
           this.source.start(0);
      }

      stop():void
      {
        if (this.source) 
        {
            try {
            this.source.stop();
            } catch (e){}
            this.source = null;
            this.start_time = 0;
        }

      }

      duration():number
      {
         if(!this.sound_asset) return 0;
         return  this.sound_asset.buffer.duration;
      }

      playback_time():number
      {
        const elapsed_total = this.sound_service.context.currentTime - this.start_time;
        const current = this.loop? elapsed_total % this.duration(): Math.min(elapsed_total, this.duration());
        return  current;
      }

      progress():number
      {
            if(!this.source || this.start_time == 0) return 0;
            return this.playback_time()/this.duration();
      }
      
    

      tick_panner():void
      {
            if(this.panner)
            {
                this.panner.positionX.setValueAtTime(this.transform.position[0], this.sound_service.context.currentTime);
                this.panner.positionY.setValueAtTime(this.transform.position[1], this.sound_service.context.currentTime);
                this.panner.positionZ.setValueAtTime(this.transform.position[2], this.sound_service.context.currentTime);
            }
      }

      override tick(delta_time:number):void
      {
         this.tick_panner();
      }
}